export default "__VITE_ASSET__rUSsDYQe__"